/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Even_Maroon_Termite_EngageInputs */

const fr_even_maroon_termite_engage = /** @type {(inputs: Even_Maroon_Termite_EngageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numéro de téléphone`)
};

/**

* @param {Even_Maroon_Termite_EngageInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const even_maroon_termite_engage = /** @type {((inputs?: Even_Maroon_Termite_EngageInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Even_Maroon_Termite_EngageInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_even_maroon_termite_engage(inputs)
});